import { Box } from "@mui/material"
import DashboardContainer from "components/smart/dashboard-container/DashboardContainer"
import AvailableCredit from "../components/AvailableCredit"
import TransactionHistory from "../components/TransactionHistory"

const RecruitmentCredit=()=>{
    return (
    <Box sx={{overflow:"hidden"}}>
        <DashboardContainer>
                <AvailableCredit/>
                <TransactionHistory/>
        </DashboardContainer>
    </Box>
    )
}
export default RecruitmentCredit